module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CUZLsN/tc-custom/9781612547732.jpg?1706936127074",
      "alt": "This image is the cover for the book Treacherous"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Treacherous\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A traumatized young girl goes on the run from powerful assassins in this supernatural Cajun thriller full of criminal corruption and voodoo magic.")]), _c('br'), _c('br'), _vm._v(" When the Piper family ﬁnds a beaten and bloodied young girl near their rural Louisiana home, they don’t think twice about taking her in. But their act of charity is about to change their lives in ways they never expected. The Pipers couldn’t possibly imagine the horrors that Madria has experienced—or the secrets she carries with her.")]), _vm._v(" When vicious men came to her home and murdered her family, Madria managed to escape—though how she survived their brutal attack is a mystery. Now those men are out to finish the job. But while they present a deadly threat, Madria possesses powers of her own.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Enjil Washington\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Brown Books Small Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0